import { render, staticRenderFns } from "./open-new-customer.vue?vue&type=template&id=f191672e&scoped=true&lang=pug&"
import script from "./open-new-customer.vue?vue&type=script&lang=js&"
export * from "./open-new-customer.vue?vue&type=script&lang=js&"
import style0 from "./open-new-customer.vue?vue&type=style&index=0&id=f191672e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f191672e",
  null
  
)

export default component.exports